<template>
  <app-logged id="DocumentAxexoIXProgramaIndex">
    <v-flex xs12>
      <validation-observer ref="observer" v-slot="{ invalid }" tag="form">
        <v-form>
          <app-widget search>
            <div slot="widget-search">
              <v-row>
                <v-col cols="12" md="10">
                  <validation-provider
                    name="industria"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="industria"
                      :items="industrias"
                      :search-input.sync="filter"
                      hide-no-data
                      label="Selecione uma industria"
                      type="text"
                      ref="search"
                      outlined
                      flat
                      hide-details
                      item-text="nome_fantasia"
                      item-value="id"
                      :return-object="false"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="2">
                  <app-button
                    x-large
                    block
                    @click.native.prevent="search"
                    :disable="invalid"
                  >
                    Buscar
                  </app-button>
                </v-col>
              </v-row>
            </div>
            <div slot="widget-content">
              <div v-if="clientes.length">
                <p
                  class="overline"
                  v-text="
                    `${
                      selection.length
                        ? `${selection.length} clientes(s) selecionado(s)`
                        : 'Nenhum cliente foi selecionado'
                    }`
                  "
                />
                <v-row>
                  <v-col cols="12" sm="3">
                    <app-button
                      block
                      text
                      color="warning"
                      @click.native.prevent="removeAll"
                    >
                      <v-icon class="mr-2" v-html="`check_box_outline_blank`" />
                      Nenhum
                    </app-button>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <app-button
                      color="warning"
                      block
                      text
                      @click.native.prevent="selectAll"
                    >
                      <v-icon class="mr-2" v-html="`check_box`" />
                      Todos
                    </app-button>
                  </v-col>
                  <v-col cols="6">
                    <app-button
                      block
                      @click.native.prevent="print"
                      :disable="!selection.length"
                    >
                      Imprimir
                    </app-button>
                  </v-col>
                </v-row>
              </div>
              <v-list v-if="clientes.length > 0">
                <v-list-item-group v-model="selection" multiple>
                  <v-list-item
                    v-for="(item, i) in clientes"
                    :key="i"
                    :three-line="!!item.fim_contrato"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-checkbox
                          v-model="active"
                          color="primary"
                          @click="toggle"
                        />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.nome_cliente" />
                        <v-list-item-subtitle
                          class="grey--text"
                          v-text="
                            `Início do contrato em ${$options.filters.date(item.inicio_contrato)}`
                          "
                        />
                        <v-list-item-subtitle
                          v-if="item.fim_contrato"
                          class="red--text font-weight-medium"
                          v-text="`Término do contrato em ${$options.filters.date(item.fim_contrato)}`"
                        />
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-list v-else>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon class="black lighten-2 white--text">
                      thumb_down
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="'Nenhum cliente foi cadastrado nesta indústria.'"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'DocumentAxexoIXProgramaIndex',
  components: {
    ValidationProvider,
    ValidationObserver,
    AppWidget,
    AppLogged,
    AppButton
  },
  data () {
    return {
      filter: '',
      industria: null,
      timeout: null,
      selection: [],
      limitValues: [
        {
          text: '10',
          value: 10
        },
        {
          text: '25',
          value: 25
        },
        {
          text: '50',
          value: 50
        },
        {
          text: 'Todos',
          value: 0
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['clientes', 'industrias'])
  },
  watch: {
    industria (val) {
      this.$store.commit('setClientes', [])
    }
  },
  methods: {
    ...mapActions(['getClientesToPrintAnexoIVEmBranco', 'printClientesAnexoIVEmBranco']),
    print () {
      if (this.selection.length) {
        const arrayOfId = this.selection.map(item => this.clientes[item].id)
        this.printClientesAnexoIVEmBranco({
          clientes: arrayOfId,
          industria: this.industria
        })
      }
    },
    selectAll () {
      this.selection = this.clientes.map((item, index) => index)
    },
    removeAll () {
      this.selection = []
    },
    search () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.getClientesToPrintAnexoIVEmBranco({
            industria: this.industria
          })
        }
      })
    }
  }
}
</script>
